
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aws-case-study/[id]",
      function () {
        return require("private-next-pages/aws-case-study/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aws-case-study/[id]"])
      });
    }
  